<template>
  <div>
    <modal :show.sync="alertModal.show" class="modal-primary" :show-close="alertModal.close" header-classes="justify-content-center" type="mini">
      <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="now-ui-icons" :class="{ 'ui-1_check' : alertModal.status == 'success', 'loader_gear spin' : alertModal.status == 'busy', 'ui-1_simple-remove' : alertModal.status == 'error'  }"></i>
      </div>
      <p>{{alertModal.message}}</p>
      <template slot="footer">
        <n-button type="neutral" link @click.native="$router.push({path :'/home'})" :disabled="alertModal.status == 'busy'">{{$t('message.Home')}}</n-button>
        <!-- <n-button type="neutral" link @click.native="alertModal.show = false && $router.push({path :'/create'})" :disabled="alertModal.status == 'busy'" v-show="$route.name == 'Create'">Create</n-button> -->
        <n-button type="neutral" link @click.native="alertModal.show = false" :disabled="alertModal.status == 'busy'"> {{$t('message.Close')}}</n-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from "src/components";

export default {
  components: { Modal },
  props: ["alertModal"],
};
</script>

